import { Component, inject, Input } from '@angular/core';
import { FeldBeschreibung } from '../../../../domain/model/feldbeschreibung.model';
import { Feld } from '../../../../domain/model/feld.enum';
import { FeldBeschreibungService } from '../../../../service/feldbeschreibung/feldbeschreibung.service';
import { Observable } from 'rxjs';

@Component({
    selector: 'redispatch-form-group-headline',
    templateUrl: './form-group-headline.component.html',
    styleUrls: [
        './form-group-headline.component.scss',
    ],
    standalone: false,
})
export class FormGroupHeadlineComponent {

    @Input()
    public feld: Feld;

    @Input()
    public showInfo: boolean = true;

    private feldBeschreibungService = inject(FeldBeschreibungService);

    public get feldBeschreibung(): Observable<FeldBeschreibung | null> {
        return this.feldBeschreibungService.getCachedFeldBeschreibung(this.feld);
    }

}
